// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"e8826192","371":"b2a43bab","453":"31bf9d75","510":"098a9ffb","821":"c51b1d23","888":"2d8e2a93","928":"7c0abfb1"}[chunkId] + ".chunk.js";
};